$(document).ready(function(){
  var arrow_left = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg></button>'
  var arrow_right = '<button class="slick-next slick-arrow" aria-label="Previous" type="button"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg></button>'
  
  $('.video_slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:arrow_left,
    nextArrow:arrow_right,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 720,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 640,
        settings: { 
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });
  $('.home-section--content.dynamic-collection-list--inner').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:arrow_left,
    nextArrow:arrow_right,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 1023,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 640,
        settings: { 
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });
  $('.home-section--content.blogposts--inner, .blog-related-products .home-section--content').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:arrow_left,
    nextArrow:arrow_right,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 1023,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 640,
        settings: { 
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });
  
  $('body').on('click','.productgrid--sidebar-title--small,.accordion--item .accordion--title',function(){  
    if($(this).hasClass('accordion--active')){
      $(this).removeClass('accordion--active');
      $(this).next().slideUp();
    }else{
      $(this).addClass('accordion--active');
      $(this).next().slideDown();    
    }
  });
  
  $.getScript( "https://cdn.shopify.com/s/files/1/0530/8501/2161/files/jquery.magnific-popup.min.js", function( data, textStatus, jqxhr ) {    
    if( jqxhr.status == 200  ){
      $('head').append( $('<link rel="stylesheet" type="text/css" />').attr('href', 'https://cdn.shopify.com/s/files/1/0530/8501/2161/files/magnific-popup.css') );
      $('.video-overlay_wrapper .video-play-button').each(function(){
        console.log("ttttt");
        var src = $(this).closest('.video').find('[data-video-url]').attr('data-video-url');
        $(this).magnificPopup({ type:'iframe', iframe: {
          markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe></div>',
          patterns: { youtube: {
            index: 'youtube.com/',
            id: function(url){ var id =  url.split('?v=')[1]; return id;
                             }, src: 'https://www.youtube-nocookie.com/embed/%id%?autoplay=1&enablejsapi=1&cc_load_policy=1&origin='+window.location.origin
          } },
          srcAction: 'iframe_src', },          
                               items:[ { src: src, type:'iframe' } ],
                               callbacks: { elementParse: function(item) { } } }); })
    }    
  });  
  
  // Brand Directory Scroll To section JS
  if($(".brand-directory").length){
       $(".brand-directory a[href^='#']").click(function(e) {
      	e.preventDefault();
      	
      	var position = $($(this).attr("href")).offset().top;
          var headerHeight = $('.site-header').height();
          var topPosition = position - headerHeight - 20;
      
      	$("body, html").animate({
      		scrollTop: topPosition
      	}, 1000 );
      });
  }

  // Mobile Menu
  var backMenu = $('.back-top-top');
  backMenu.click(function() {
  	$(this).parent('.navmenu-submenu').removeClass('visible');
  	$(this).parent().siblings('.navmenu-link-parent').removeClass('navmenu-link-parent-active');
  	$(this).parent().siblings('.navmenu-button').attr('aria-expanded', 'false');
  
  	// Child Class Remove
  	$(this).siblings('.navmenu').find('.navmenu-link-parent').removeClass('navmenu-link-parent-active');
  	$(this).siblings('.navmenu').find('.navmenu-submenu').removeClass('visible');
  	$(this).siblings('.navmenu').find('.navmenu-button').attr('aria-expanded', 'false');
  });
  /* $('.select-option-name').chosen({width: "50%"}).on('change', function(event) {
     if(event.target == this){
        alert($(this).val());
     }
      var selectedValue = this.value;
      var gridItems = document.querySelectorAll('.grid-item');
      
      gridItems.forEach(function(item) {
        if (selectedValue === 'all' || item.classList.contains(selectedValue)) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
       
  });*/
  
 
});

// CD CODE
$(document).on('click', '.coll_read_more', function(e) {  
  if($(this).parent('.collection_desc').hasClass('desc_readmore')){
    $('.collection_desc').removeClass('desc_readmore');
    $(this).text('Read less');
  }else{
    $(this).parent('.collection_desc').addClass('desc_readmore');
    $(this).text('Read more');
  }
});